import React from "react";
import { Sparkles } from "lucide-react";
import { GhlEmbedPlaceholder } from "@/components/GhlEmbedPlaceholder";
import { SITE } from "@/constants/testIds";

const BENEFITS = [
    "Available in person on Maui or worldwide over Zoom",
    "No question is too small — we welcome curious beginners",
    "Insurance-eligible superbills available on request",
];

export const HomeConsultationSection = () => (
    <section
        data-testid={SITE.homeContactCta}
        id="consultation"
        className="py-14 sm:py-20"
    >
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
                <div className="lg:col-span-5">
                    <p className="font-accent text-xs text-terracotta">START YOUR JOURNEY</p>
                    <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                        Request a consultation
                    </h2>
                    <p className="mt-3 text-foreground/80 leading-relaxed">
                        Tell us a bit about you. Riley personally reviews every request and will reach out within 1–2 business days to schedule.
                    </p>
                    <ul className="mt-5 space-y-2 text-sm text-foreground/80">
                        {BENEFITS.map((b) => (
                            <li key={b} className="flex items-start gap-2">
                                <Sparkles className="mt-0.5 h-3.5 w-3.5 text-sage shrink-0" />
                                {b}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="lg:col-span-7">
                    <GhlEmbedPlaceholder kind="consultation-form" />
                </div>
            </div>
        </div>
    </section>
);

export default HomeConsultationSection;
